








































// Versione custom del componente https://github.com/bastidest/vue-step-progress/
import { Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Step from '@/interfaces/IStep';
import { PropType } from 'vue';
import { ContractStep, STEP_ENUM } from '@/entity/Net20/ContractStep';
import moment from 'moment';
import { i18n } from '@/i18n/i18n-setup';
import { NET20_CONTRACT_TYPE } from '@/services/Enums';

@Component
export default class StepProgressCustom extends Vue {
    @Prop({
        type: Array as PropType<Array<Step>>,
        default: []
    })
    steps: Step[];

    @Prop({
        type: Array as PropType<Array<ContractStep>>,
        default: []
    })
    contractSteps: ContractStep[];

    @Prop({
        type: Number,
        default: 0
    })
    contractType: number;

    @Prop({
        type: Number,
        default: 0
    })
    currentStep: number;

    @Prop({
        type: Number,
        default: 0
    })
    lastStepBeforeRefuse: number;

    @Prop({
        type: String,
        default: 'fa fa-check'
    })
    iconClass: String;

    @Prop({
        type: String,
        default: 'red'
    })
    activeColor: String;

    @Prop({
        type: String,
        default: 'gray'
    })
    passiveColor: String;

    @Prop({
        type: Number,
        default: 5
    })
    activeThickness: Number;

    @Prop({
        type: Number,
        default: 5
    })
    passiveThickness: Number;

    @Prop({
        type: Number,
        default: 12
    })
    lineThickness: Number;

    loaded: boolean = false;
    STEP_ENUM_LIST = STEP_ENUM;
    latestStepInfos: Array<ContractStep> = [];
    lastStep: ContractStep = null;
    isRejected: boolean =  false;
    isContractStepBack = false;
    moment = moment;

    mounted() {
      this.initStepInfo();
    }

    @Watch('contractSteps')
    onChangeContractSteps(newValue, oldValue) {
      if(newValue != oldValue)
        this.initStepInfo()
    }

    initStepInfo() {
      this.getLatestStepInfos();
      this.getLatestStep();
      this.setIsRejected();
      this.setIsContractStepBack();
      this.loaded = true;
    }

    getLatestStepInfos() {
      let lastStep: ContractStep;
      this.latestStepInfos = [];
      this.contractSteps.map(cs => cs.idStep).filter((value, index, self) => self.indexOf(value) === index).forEach(x => {
        
        lastStep = this.contractSteps.filter(cs => cs.idStep == x)[0];
        if(lastStep !== undefined && (lastStep.note == null || lastStep.note === ''))
          lastStep.note = i18n.t("NET20.NO_NOTES_STEP") as string;
        this.latestStepInfos.push(lastStep);
      });
    }

    getLatestStep() {
      this.lastStep = this.contractSteps.sort((a, b) => (b.dataStep > a.dataStep ? 1 : -1))[0];
    }

    setIsRejected() {
      //i due step da cui e' possibile effettuare il reject
      let rejectableLastStep = this.latestStepInfos.filter(x => x.idStep != this.lastStep.idStep).sort((a, b) => (b.dataStep > a.dataStep ? 1 : -1))[0];
      if(rejectableLastStep != null && (rejectableLastStep.idStep == STEP_ENUM.SIGNAGE_ORDER ||rejectableLastStep.idStep == STEP_ENUM.APPROVAL)) {
        let closestLesserStep = this.findClosestLesserStep(this.steps, rejectableLastStep.idStep);
        if(closestLesserStep != null && this.lastStep.idStep == this.currentStep && this.currentStep == closestLesserStep.idStep)
          this.isRejected = true;
      }
    }

    setIsContractStepBack() {
      if(this.lastStep != null && this.lastStep.idStep > this.currentStep)
        this.isContractStepBack = true;
    }

    getStepInfoByIdStep(idStep: number): ContractStep {
      let stepInfo;
      if(!this.isRejected && this.currentStep != STEP_ENUM.REFUSED) {
        if(idStep == STEP_ENUM.INSTALLED_SIGNAGE) {
          stepInfo = this.latestStepInfos.filter(x => x.idStep == STEP_ENUM.CLOSED)[0];
        } else if (idStep == STEP_ENUM.CLOSED) {
          stepInfo = new ContractStep();
        } else {
             stepInfo = this.findClosestGreaterStep(this.latestStepInfos, idStep);
        }
      } else if(this.isRejected) {
          stepInfo = this.latestStepInfos.filter(x => x.idStep == idStep)[0];
      } else if(this.currentStep == STEP_ENUM.REFUSED) {
        if(idStep == STEP_ENUM.REFUSED)
          stepInfo = this.latestStepInfos.filter(x => x.idStep == STEP_ENUM.REFUSED)[0];
        else if(this.lastStepBeforeRefuse == STEP_ENUM.CLOSED && idStep == Math.max(...this.latestStepInfos.filter(x => x.idStep != STEP_ENUM.REFUSED && x.idStep != STEP_ENUM.CLOSED).map(x => x.idStep)))
          stepInfo = this.latestStepInfos.filter(x => x.idStep == STEP_ENUM.CLOSED)[0];
        else if(idStep == this.lastStepBeforeRefuse)
          stepInfo = new ContractStep();
        else
          stepInfo = this.findClosestGreaterStep(this.latestStepInfos, idStep);
      }
      return stepInfo;
    }

    findClosestGreaterStep(steps: Array<ContractStep>, idStep: number) {
      const greaterStep = steps.filter(x => x.idStep > idStep);
      return greaterStep.length > 0 ? greaterStep.reduce((prev, curr) => Math.abs(curr.idStep - idStep) < Math.abs(prev.idStep - idStep) ? curr : prev) : new ContractStep();
    }

    findClosestLesserStep(steps: Array<Step>, idStep: number) {
          const lesserStep = steps.filter(x => x.idStep < idStep);
          return lesserStep.length > 0 ? lesserStep.reduce((prev, curr) => Math.abs(curr.idStep - idStep) < Math.abs(prev.idStep - idStep) ? curr : prev) : null;
    }

    isPopoverNotesVisibile(step: Step) {
      let check = false;
      if(this.contractType != NET20_CONTRACT_TYPE.RENEWAL) {
        if(this.currentStep == step.idStep) {
          if(this.isRejected || this.currentStep == STEP_ENUM.REFUSED) 
            check = true;
        } else if(step.idStep < this.currentStep) {
          if(this.currentStep == STEP_ENUM.REFUSED && step.idStep < this.lastStepBeforeRefuse)
            check = true;
          else if(this.currentStep != STEP_ENUM.REFUSED)
            check = true;
        }         
      }
      return check;
    }    

    checkContractStepBack() {
      var check = false;
      if(this.lastStep != null && this.lastStep.idStep > this.currentStep)
        check = true;
      return check
    }

    get scaleX(){
        let step = this.steps.findIndex(x => x.idStep == this.currentStep) + 1;
        if(step < 0) {
            step = 0;
        } else if (step >= this.steps.length) {
            step = this.steps.length - 1;
        }
        return step / ((this.steps.length) - 1);
    }
}
